import Entities from 'STORE';

// Needs Bff implementation
const request = async () => {
  // try {
  //   return false;
  // } catch (error) {
  //   logger.get('API').error('spaces.updateGroupsVisibility', error);
  //   return false;
  // }
  return false;
};

export const changeAllGroupsVisibility = async ({ spaceId, isVisible }) => {
  const space = Entities.spacesStore.getById(spaceId);
  if (!space) {
    return false;
  }

  space.groupVisibility.setAllGroupsVisible(isVisible);

  const result = await request(space, isVisible);
  if (!result) {
    space.groupVisibility.setAllGroupsVisible(!isVisible);
  }

  return result;
};
